'use strict';

var Sugar = require('sugar-core'),
    PrimitiveRangeConstructor = require('../range/var/PrimitiveRangeConstructor');

Sugar.String.defineStatic({

  'range': PrimitiveRangeConstructor

});

module.exports = Sugar.String.range;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/string/range.js
// module id = 920
// module chunks = 0